<template>
    <div :key="updateResult">
      <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
        <div v-html="toastMsg"></div>
      </b-toast>
      <div class="iq-card" id="ansExpCont">
        <div class="iq-card-header">
          <div class="row mb-2">
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-2">
              <h4>
                <i class="fa-solid fa-magnifying-glass-chart font-size-20 primary-color"></i>
                Assessment Review<br>
                <b>{{ getTestName(appDetails)?.toUpperCase() }}</b>
              </h4>
              <span>
                <b>{{userDetails.user_name}}</b><br>
                <span style="color:#000">Assessment Date:&nbsp;{{ quizReport.created_on | dateFormatDDMMYY }}</span>
              </span>
              <div class="mt-2">
                <i class="fa-solid fa-square-poll-vertical font-size-20 pointer primary-color mt-1" :style="isResultUnpublished && !isAdminOrCounselor ? 'pointer-events:none;opacity:0.5' : ''" @click="goToTestSeriesAttempts()" title="Attempts"></i>
                <i v-if="appDetails.app_name?.toLowerCase().includes('mock') || appDetails.app_name?.toLowerCase().includes('a-thon')" class="fa-solid fa-file-text font-size-20 pointer primary-color ml-3" :style="isResultUnpublished && !isAdminOrCounselor ? 'pointer-events:none;opacity:0.5' : ''" @click="goToReportCard()" title="View Report Card"></i>
                <i v-if="appDetails.app_name?.toLowerCase().includes('mock')" class="fa-solid fa-chart-pie font-size-20 pointer primary-color ml-3" :style="isResultUnpublished && !isAdminOrCounselor ? 'pointer-events:none;opacity:0.5' : ''" @click="goToAnalysisV1Report(quizReport)"></i>
                <i v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" class="fa-solid fa-edit pointer font-size-20 primary-color pointer ml-3" @click="gotoEditQuiz(quizReport.app_id)"></i>
                <i v-if="appDetails.app_name?.toLowerCase().includes('mock') && (userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118')" @click="openSendmailToUserModal()"  class="fa fa-envelope font-size-20 primary-color ml-3 pointer"></i>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-5 mt-2 mb-2 sccore-outline-box">
              <!-- Total Score Display -->
              <div class="total-score mb-2" v-if="getTestName(appDetails)?.toUpperCase().includes('MOCK')">
                <span class="text-dark font-weight-bold">Total Score</span>
                <div class="d-flex my-1 align-items-center">
                  <b-badge variant="primary" class="font-size-18 px-3 py-2 font-weight-bold">
                    {{ totalScore }} / {{ totalScoreRangeMax }}
                  </b-badge>
                </div>
              </div>

              <!-- Section Scores Display -->
              <div v-if="showCategoryWiseScores" class="mt-2">
                <span class="text-dark font-weight-bold">Section Scores</span>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <div
                    v-for="(quizCategory, index) in FINAL_CHAIN_LIST"
                    :key="index"
                    class="mr-2 mb-2"
                  >
                    <b-badge variant="primary" class="font-size-14 px-3 py-1 text-capitalize score-outline-badge">
                      <span class="font-weight-bold">{{ quizCategory.app_name_alias }}</span>: {{ quizCategory.app_score }}
                    </b-badge>
                  </div>
                </div>
              </div>

              <!-- Predicted AP Score Display (mocks only, not practice) -->
              <div v-if="appCategory.toLowerCase().includes(appNameWithAP.toLocaleLowerCase()) && getTestName(appDetails)?.toUpperCase().includes('MOCK')" class="total-score mt-2 mb-1">
                <span class="text-dark font-weight-bold">Predicted AP Score</span><br>
                <div class="d-flex my-1 align-items-center">
                  <b-badge variant="primary" class="font-size-18 px-3 py-2 font-weight-bold score-outline-badge">
                    {{ apScore }}
                  </b-badge>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3 mt-3 mb-2">
              <span class="name_deatils mr-4">
                <h5>{{userDetails.user_name}}</h5>
                <span class="information-color">#&nbsp;Total Questions:&nbsp;&nbsp;{{quizReport.total_questions}}</span><br>
                <span class="success-color">#&nbsp;Correct Answers:&nbsp;&nbsp;{{quizReport.correct_answers ? quizReport.correct_answers : 0}}</span><br>
                <span class="primary-color">#&nbsp;Wrong Answers:&nbsp;&nbsp;{{quizReport.wrong_answers ? quizReport.wrong_answers : 0}}</span><br>
                <span class="warning-color">#&nbsp;Unanswered:&nbsp;&nbsp;{{quizReport.skipped_answers ? quizReport.skipped_answers : 0}}</span><br>
                <span style="color:#000">#&nbsp;Time Taken:&nbsp;&nbsp;{{ getCompleteTimeTaken(quizReport) | convertSecondsToMinutesAndSeconds }}&nbsp;<i class="ri-timer-line"></i></span><br/>
                <span v-if="VUE_APP_TRUSTED_EMAILS.includes(userData.user_email)" style="color:#000">#&nbsp;Actual Time Taken:&nbsp;&nbsp;{{ getCompleteTimeTaken(quizReport, true) | convertSecondsToMinutesAndSeconds }}&nbsp;<i class="ri-timer-line"></i></span>
              </span>
            </div>
          </div>
          <!-- Full width publish status strip at the bottom of the header card: shown to the student while the FRQ result is under evaluation, and always to admin/counselor along with the publish toggle -->
          <div v-if="isResultUnpublished || (isApFrqResult && isAdminOrCounselor)" :class="['unpublished-msg', 'd-flex', 'align-items-center', { 'published-msg': !isResultUnpublished }]">
            <template v-if="isResultUnpublished">
              <i class="fa-solid fa-hourglass-half primary-color font-size-18 mr-3"></i>
              <span>
                <span class="primary-color font-weight-bold">Evaluation in progress</span>
                <span class="text-muted unpublished-msg-desc ml-2">Final scores & report card will be published after evaluation</span>
              </span>
            </template>
            <template v-else-if="resultDeleted === RESULT_DELETED">
              <i class="fa-solid fa-trash text-secondary font-size-18 mr-3"></i>
              <span class="text-secondary font-weight-bold">This attempt is deleted</span>
            </template>
            <template v-else>
              <i class="fa-solid fa-circle-check success-color font-size-18 mr-3"></i>
              <span>
                <span class="success-color font-weight-bold">Result published</span>
                <span class="text-muted unpublished-msg-desc ml-2">Scores & report card are visible to the student</span>
              </span>
            </template>
            <b-button
              v-if="isApFrqResult && isAdminOrCounselor"
              size="sm"
              class="ml-auto text-white text-nowrap"
              :variant="resultPublishStatus.variant"
              :disabled="resultDeleted === RESULT_DELETED || publishInProgress"
              :title="resultPublishStatus.title"
              @click="toggleResultPublish()"
            >
              {{ resultPublishStatus.label }}
            </b-button>
          </div>
        </div>
      </div>

      <div v-if="loadingAnswers">
        <div class="text-center py-4">
          <b-spinner label="Loading responses..." variant="primary"></b-spinner>
          <div class="mt-2">Loading responses...</div>
        </div>
      </div>
      <div v-else-if="questionList?.length <= 0">We detected some issue with your attempt. <span class="pointer primary-color" @click="goToTestSeriesAttempts()">Click here </span>to re-attempt this assessment</div>

      <!-- Analysis Question wise grid -->
      <div v-if="questionList?.length > 0" class="iq-card row p-3 m-1">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h4>Response Analysis</h4>
          <p>Analyse your responses by clicking on the question</p>
        </div>

        <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2 mb-2 p-3" v-for="(questionList, appName) of questionGridData" :key="appName">
          <h6 class="pl-0 mb-2 twoLineOnly">
            {{ removeUnwantedText(appName) }}
          </h6>
          <h6 class="mb-2">
            <small><i class="ri-timer-line primary-color"></i>&nbsp;{{ getCategoryTimeSpent(questionList[0]) | convertSecondsToMinutesAndSeconds }}</small>
          </h6>
          <!-- Pills for question status -->
          <div class="pill-container" v-if="questionList?.length">
            <b-badge
              v-for="(ques, index) in questionList"
              :key="'pill-' + index"
              pill
              class="ml-0 font-size-14 pill_badge_box pointer"
              @click="quizQuestionviewV1('MODAL', ques, index + 1)"
              :style="{ backgroundColor: getOptionColor(ques), color: '#fff' }"
            >
              {{ index + 1 }}
            </b-badge>
            <h6 v-if="VUE_APP_TRUSTED_EMAILS.includes(userData.user_email)" class="mb-2">
              <small><i class="ri-timer-line primary-color"></i>&nbsp;{{ getCategoryTimeSpent(questionList[0], true) | convertSecondsToMinutesAndSeconds }}</small>
            </h6>
          </div>
        </div>
      </div><!-- Analysis Question wise grid -->

      <!-- Details: Question wise table -->
      <div v-if="questionList?.length > 0" class="iq-card row p-3 m-1">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h4>Category Analysis</h4>
          <p>Analyse the questions for each module according to category, skill and difficulty level</p>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2" v-if="quizReport && quizReport?.chained_apps && quizReport?.chained_apps?.length > 1">
          <b-tabs v-model="activeAppIndex" pills class="pull-right" id="answer_exam_tabs">
            <b-tab
              v-for="(app, index) in quizReport.chained_apps"
              :key="index"
              :title="app.app_name_alias ? app.app_name_alias : app.app_name"
              @click="gotoNextAppAnalysis(app, index)"
              class="custom-pill"
            />
          </b-tabs>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <b-col md="12" v-if="questionList && questionList.length > 0">
            <div>
              <b-table
                hover
                responsive
                :items="questionList"
                :fields="columns"
                :no-border-collapse="true"
              >
                <template v-slot:cell(id)="data">
                  <span class="pointer" @click="quizQuestionviewV1('MODAL', data.item)">Q{{ data.index + 1 }}</span>
                </template>

                <template v-slot:cell(user_response)="data">
                  <div style="gap: 10px;" class="d-flex align-items-center" v-if="data.item.is_mcq === 0 && data.item.user_response?.toLowerCase() !== 'z' && data.item.user_response !== ''" :title="getUserResponseTooltip(data.item)" @click="quizQuestionviewV1('MODAL', data.item)">
                    <span :class="getOptionColor(data.item, true)">{{ displayUserResponse(data.item.user_response) }}</span>
                    <span v-if="data.item.answer_image">
                      <img :src="pdfLogo" class="me-2 pointer" style="height: 24px;"/>
                    </span>
                  </div>
                  <div v-else :class="getOptionColor(data.item, true)" :title="getUserResponseTooltip(data.item)" @click="quizQuestionviewV1('MODAL', data.item)">
                    {{ data.item.user_response?.toLowerCase() === 'z' ? '-' : displayUserResponse(data.item.user_response) }}
                  </div>
                </template>

                <template v-slot:cell(correct_answers)="data">
                  <div class="'pill_badge_box bg_green text-green font-semibold rounded pl-2 pr-2 pointer text-capitalize" @click="quizQuestionviewV1('MODAL', data.item)">
                    {{data?.item?.correct_answers?.length > 5 ? data.item.correct_answers.substring(0, 5) + "..." : data.item.correct_answers}}
                  </div>
                </template>
              </b-table>
            </div>
          </b-col>
        </div>
      </div><!-- Details: Question wise table -->

      <!--Quiz Question View -->
      <b-modal
        v-model="showModelQuestionQuizViewV1"
        scrollable
        :title="cvViewModalHeaderV1"
        size="xxl"
      >
        <QuestionQuizViewV1 :propOpenedInModal="true" :propQuestionBankObj="QuestionQuizViewObj" @emitCloseQuestionQuizViewModal="closeQuestionQuizViewModalV1" />
        <template #modal-footer="">
          <b-button size="sm" @click="showModelQuestionQuizViewV1 = false">
            Close
          </b-button>
        </template><!--Quiz Question View -->
      </b-modal><!--Quiz Question View -->

      <!-- SendMail -->
      <b-modal
        v-model="showModelSendMail"
        scrollable
        :title="cvSendMailModalHeader"
      >
        <SendMail :propOpenedInModal="true" :propSendMailObj="sendMailObj" propModuleName="testseries"
        @emitCloseSendmailToUserModal="emitCloseSendmailToUserModal" />
        <template #modal-footer="">
          <b-button size="sm" @click="emitCloseSendmailToUserModal()">
            {{cvbtnModalCancel}}
          </b-button>
        </template>
      </b-modal><!-- SendMail -->

    </div>
</template>

<script>
import { socialvue } from "../config/pluginInit.js"
import { QuizAnswers } from "../FackApi/api/quizAnswers.js"
import { User } from "../FackApi/api/user.js"
import { Apps } from "../FackApi/api/apps.js"
import { base64decode } from "nodejs-base64"
import QuestionQuizViewV1 from "../views/Gide/QuizBank/QuestionQuizViewV1.vue"
import pdfLogo from "../assets_gide/img/logo/pdfLogo.png"
import SendMail from "../components/SendMail.vue"
import SendMailModules from "../FackApi/json/SendMailModules.json"
import "katex/dist/katex.min.css"
import katex from "katex"
import { AppResults } from "../FackApi/api/appResults.js"
import ApiResponse from "../Utils/apiResponse.js"
import { satModuleScoreCalculation, satScoreCalculation, psat8And9ScoreCalculation, clatScoreCalculation, cuetScoreCalculation, apScoreCalculation } from "../Utils/gideprepScoreCalculation.js"

// Matches "AP" (AP-BIOLOGY-MOCK, TESTSERIES_AP_...) but not words like "APTITUDE"
const AP_CATEGORY_REGEX = /(^|[^a-z])ap([^a-z]|$)/i

export default {
  name: "AnswerAnalysis",
  data () {
    return {
      questionList: [],
      appId: null,
      gideUserId: null,
      aprsId: null,
      interestId: null,
      userDetails: {},
      appDetails: {},
      quizReport: {},
      offset: 1,
      dontCallAPI: false,
      cvbtnModalCancel: "Cancel",
      loadingAnswers: true,
      updateResult: 0,
      activeAppIndex: 0,
      showModelQuestionQuizViewV1: false,
      QuestionQuizViewObj: null,
      SendMailModules: SendMailModules,
      showModelSendMail: false,
      cvSendMailModalHeader: "Send Email",
      sendMailObj: null,
      cvViewModalHeaderV1: "View Question Analysis",
      questionGridData: {},
      columns: [
        { label: "Question No.", key: "id", class: "text-left align-text-top", sortable: false },
        { label: "correct answers", key: "correct_answers", class: "text-left align-text-top", sortable: false },
        { label: "user response", key: "user_response", class: "text-left align-text-top", sortable: false },
        { label: "category", key: "qbk_category", class: "text-left align-text-top", sortable: false },
        { label: "difficulty", key: "difficulty", class: "text-left align-text-top", sortable: false }
      ],
      pdfLogo: pdfLogo,
      attempt: null,
      quizResultDetail: {},
      appCategory: "",
      showCategoryWiseScores: false,
      totalScore: 0,
      apScore: 0,
      totalScoreRangeMin: "",
      totalScoreRangeMax: "",
      isSATaTHON_or_MOCK: false,
      isPSAT: false,
      appNameWithMOCK: "MOCK-",
      appNameWithTHON: "-THON",
      appNameWithSAT: "SAT-",
      appNameWithPSAT: "PSAT",
      psatTotalScoreMax: "1440", // PSAT 8&9: 120-720 per section
      appNameWithCLAT: "CLAT-",
      appNameWithCUET: "CUET-",
      appNameWithAP: "AP",
      FINAL_CHAIN_LIST: null,
      RESULT_PUBLISHED: 0,
      RESULT_DELETED: 1,
      RESULT_UNPUBLISHED: 2,
      publishInProgress: false,
      showToast: false,
      toastMsg: "",
      toastVariant: "default",
      toastTitle: "Assessment Review",
      SAT_FINAL_CHAIN_LIST: { "English": { "app_name_alias": "English", "app_score": 0, "correct_answer_module1": 0, "correct_answer_total": 0 }, "Maths": { "app_name_alias": "Maths", "app_score": 0, "correct_answer_module1": 0, "correct_answer_total": 0 } },
      VUE_APP_TRUSTED_EMAILS: process.env.VUE_APP_TRUSTED_EMAILS
    }
  },
  components: {
    QuestionQuizViewV1,
    SendMail
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    isAdminOrCounselor () {
      return this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118"
    },
    /**
     * AP attempt having at least one FRQ, which needs evaluation before the result is published
     */
    isApFrqResult () {
      return AP_CATEGORY_REGEX.test(this.appCategory) && !!this.quizResultDetail?.chains?.some(chainedApp => chainedApp.frq_count > 0)
    },
    /**
     * Publish status of the whole attempt: unpublished if any app of the chain is unpublished,
     * so every section (MCQ/FRQ) of the attempt shows the same status
     */
    resultDeleted () {
      const chainDeletedList = (this.quizResultDetail?.chains ?? []).map(chainedApp => Number(chainedApp.deleted ?? this.RESULT_PUBLISHED))
      if (chainDeletedList.includes(this.RESULT_UNPUBLISHED)) {
        return this.RESULT_UNPUBLISHED
      }
      return Number(this.quizResultDetail?.deleted ?? this.RESULT_PUBLISHED)
    },
    isResultUnpublished () {
      return this.isApFrqResult && this.resultDeleted === this.RESULT_UNPUBLISHED
    },
    resultPublishStatus () {
      if (this.resultDeleted === this.RESULT_DELETED) {
        return { label: "Deleted", variant: "secondary", title: "This attempt is deleted" }
      }
      if (this.resultDeleted === this.RESULT_UNPUBLISHED) {
        return { label: "Unpublished", variant: "warning", title: "Click to publish the result to the student" }
      }
      return { label: "Published", variant: "success", title: "Click to unpublish the result" }
    }
  },
  async mounted () {
    socialvue.index()
    this.appId = this.$route.params.appId
    this.gideUserId = this.$route.params.gide_user_id ? this.$route.params.gide_user_id : this.userData.user_id
    this.aprsId = this.$route.params.aprsId
    this.interestId = this.$route.query.interest_id ? this.$route.query.interest_id : null
    this.attempt = this.$route.query.attempt ? this.$route.query.attempt : null

    this.getUserDetails()
    this.getAppDetails()

    await this.getResultDetail()
    this.getQuizReportList()
    this.getAppAnswerExplanation()
  },
  methods: {
    /**
     * getResultDetail
     */
    async getResultDetail () {
      let payload = {
        app_id: this.appId,
        attempt: this.attempt ? this.attempt : 1
      }

      if (this.userData.user_id != this.gideUserId && (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118")) {
        payload.other_user_id = this.gideUserId
      }

      let appResultViewResp = await AppResults.appResultView(this, payload)
      if (!appResultViewResp.resp_status) {
        ApiResponse.responseMessageDisplay(this, appResultViewResp)
        return
      }

      appResultViewResp.resp_data.data.user_name = this.userData.user_name
      this.quizResultDetail = appResultViewResp.resp_data.data
      this.appCategory = this.quizResultDetail.app_category ? this.quizResultDetail.app_category : ""
      this.isPSAT = this.appCategory.toUpperCase().includes(this.appNameWithPSAT)
      this.isSATaTHON_or_MOCK = this.isPSAT || ((this.appCategory.toLowerCase().includes(this.appNameWithSAT.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithCLAT.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithAP.toLowerCase())) && (this.appCategory.toLowerCase().includes(this.appNameWithMOCK.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithTHON.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithAP.toLowerCase())))

      this.totalScore = 0

      if (this.isSATaTHON_or_MOCK) {
        // PSAT is checked before SAT as "PSAT-" also contains "SAT-"
        if (this.isPSAT) {
          this.totalScoreRangeMax = this.psatTotalScoreMax

          this.quizResultDetail.chains.map((chainedApp) => {
            satScoreCalculation(chainedApp, this)
          })

          for (let key in this.SAT_FINAL_CHAIN_LIST) {
            psat8And9ScoreCalculation(key, this.SAT_FINAL_CHAIN_LIST[key], this)
            this.totalScore += this.SAT_FINAL_CHAIN_LIST[key].app_score || 0
          }
          this.FINAL_CHAIN_LIST = this.SAT_FINAL_CHAIN_LIST

          this.showCategoryWiseScores = true
        }
        else if (this.appCategory.includes(this.appNameWithSAT)) {
          // this.totalScoreRangeMin = "200"
          this.totalScoreRangeMax = "1600"

          this.quizResultDetail.chains.map((chainedApp) => {
            satScoreCalculation(chainedApp, this)
          })

          for (let key in this.SAT_FINAL_CHAIN_LIST) {
            satModuleScoreCalculation(key, this.SAT_FINAL_CHAIN_LIST[key], this)
            this.totalScore += this.SAT_FINAL_CHAIN_LIST[key].app_score
          }
          this.FINAL_CHAIN_LIST = this.SAT_FINAL_CHAIN_LIST

          this.showCategoryWiseScores = true
        }
        else if (this.appCategory.includes(this.appNameWithCLAT)) {
          // this.totalScoreRangeMin = "(-30)"
          this.totalScoreRangeMax = "120"

          this.quizResultDetail.chains.map((chainedApp) => {
            this.totalScore += clatScoreCalculation(chainedApp, this)
          })

          this.FINAL_CHAIN_LIST = this.quizResultDetail.chains

          this.showCategoryWiseScores = true
        }
        else if (this.appCategory.includes(this.appNameWithCUET)) {
          const totalSubjects = this.quizResultDetail.chains?.length ?? 0
          // this.totalScoreRangeMin = `(${totalSubjects * -1 * 50})`
          this.totalScoreRangeMax = `${totalSubjects * 5 * 50}`

          this.quizResultDetail.chains.map((chainedApp) => {
            this.totalScore += cuetScoreCalculation(chainedApp, this)
          })

          this.FINAL_CHAIN_LIST = this.quizResultDetail.chains
        }
        else if (this.appCategory.includes(this.appNameWithAP)) {
          // chains sorted alphabetically keep the exam order: MCQ section first then FRQ
          this.quizResultDetail.chains.sort((chainA, chainB) => Number(chainA.frq_count > 0) - Number(chainB.frq_count > 0))
          const scoreObj = apScoreCalculation(this.quizResultDetail.chains, this)
          this.FINAL_CHAIN_LIST = [
            {
              app_name_alias: "MCQ Score",
              app_score: scoreObj?.mcq_stats ? scoreObj.mcq_stats : 0
            },
            {
              app_name_alias: "FRQ Score",
              app_score: scoreObj?.frq_stats ? scoreObj.frq_stats : 0
            }
          ]

          this.apScore = scoreObj?.ap_score ? scoreObj.ap_score : 0

          this.totalScore = scoreObj?.combined_score_obtained ? scoreObj.combined_score_obtained : 0
          this.totalScoreRangeMax = scoreObj?.combined_total_score ? scoreObj.combined_total_score : 0
          this.showCategoryWiseScores = this.appCategory.toLowerCase().includes(this.appNameWithAP.toLocaleLowerCase()) && this.getTestName(this.appDetails)?.toUpperCase().includes("MOCK")
        }
      }
    },
    /**
     * goTo AnalysisV1 Report
     */
    goToAnalysisV1Report (appData) {
      window.open(`/analytics?app_id=${appData.app_id}&gide_user_id=${this.gideUserId}&interest_id=${this.interestId}&aprs_id=${this.aprsId}&attempt=${this.attempt}`)
    },
    /**
     * goTo TestSeries Attempts Report
     */
    goToTestSeriesAttempts () {
      this.$router.push(`/attempt_list/${this.appId}/${this.appId}?gide_user_id=${this.gideUserId}`)
    },
    /**
     * goTo Report Card of this attempt, same route as the attempt list "View Report Card"
     */
    goToReportCard () {
      this.$router.push(`/app_result_view_v1/${this.appId}/${this.gideUserId}/${this.aprsId}/${this.attempt || 1}`)
    },
    /**
     * getAppAnswerExplanation
     */
    async getAppAnswerExplanation (calledForNewApp = false) {
      this.loadingAnswers = true
      const payload = {
        app_id: this.appId,
        other_user_id: this.gideUserId,
        aprs_id: this.aprsId
      }

      if (this.attempt) {
        payload.attempt = this.attempt
      }

      try {
        if (!this.dontCallAPI) {
          const appAnswerExplanationResp = await QuizAnswers.quizAnswersExplanationListV1(this, payload, this.offset)
          if (appAnswerExplanationResp.resp_status) {
            const chainOrder = this.quizResultDetail?.chains?.map((chainedApp) => chainedApp.app_name) ?? []
            const sortedAppNames = Object.keys(appAnswerExplanationResp.resp_data.data).sort((a, b) => chainOrder.indexOf(a) - chainOrder.indexOf(b))

            // On refresh (after grading) keep the list of the currently selected module tab
            const selectedAppName = !calledForNewApp && this.quizReport?.chained_apps?.[this.activeAppIndex]?.app_name
            const listAppName = selectedAppName && appAnswerExplanationResp.resp_data.data[selectedAppName] ? selectedAppName : sortedAppNames[0]

            this.questionList = []
            this.questionList.push(...appAnswerExplanationResp.resp_data.data[listAppName])

            this.questionGridData = sortedAppNames.reduce((obj, appName) => { obj[appName] = appAnswerExplanationResp.resp_data.data[appName]; return obj }, {})

            var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
            for (let i in this.questionList) {
              if (this.questionList[i].answer_explanation) {
                this.questionList[i].answer_explanation = base64regex.test(this.questionList[i].answer_explanation) ? base64decode(this.questionList[i].answer_explanation) : this.questionList[i].answer_explanation
                // this.questionList[i].answer_explanation = this.questionList[i].answer_explanation.replace(/\n\n/g, "<br/><br/>").replace(/\\/g, "")
                /*
                * For Future Use to detect LaTex Script. ~ => Space, //=> Newline.
                * Currently can't enter multiple new lines as Katex does not recognise it
                * IS_LATEX_RESPONSE needs to be added in the GPT Response
                */
                let answerExplanationLatex = ""
                if (this.questionList[i].answer_explanation.includes("IS_LATEX_RESPONSE")) {
                  this.questionList[i].answer_explanation = this.questionList[i].answer_explanation.replace("IS_LATEX_RESPONSE", "")
                  answerExplanationLatex = this.questionList[i].answer_explanation.replace(/ /g, "~").replace(/\\\[/g, "").replace(/\\\]/g, "").replace(/\\\(/g, "").replace(/\\\)/g, "").replace(/\n/g, "\\")
                  answerExplanationLatex = katex.renderToString(answerExplanationLatex, { throwOnError: false })
                  this.questionList[i].answer_explanation = answerExplanationLatex
                }

                this.questionList[i].answer_explanation = this.questionList[i].answer_explanation.replace("IS_LATEX_RESPONSE", "")
                this.questionList[i].answer_explanation = this.questionList[i].answer_explanation.replace(/\n/g, "<br/>").replace(/\\/g, "")
              }
            }
          }
          else {
            this.questionList = []
            this.dontCallAPI = true
          }
        }
      }
      catch (err) {
        console.error("Exception in getAppAnswerExplanation()", err)
        this.questionList = []
        this.dontCallAPI = true
      }
      finally {
        this.loadingAnswers = false
      }
    },
    /**
     * getUserDetails
     */
    async getUserDetails () {
      const user = await User.userView(this, this.gideUserId, this.userData.user_id)
      if (user.resp_status) {
        this.userDetails = user.resp_data.data
      }
    },
    /**
     * getAppDetails
     */
    async getAppDetails () {
      const app = await Apps.appView(this, this.appId)
      if (app.resp_status) {
        this.appDetails = app.resp_data.data

        // @TODO The Interest Should come from the backend and set
        if (!this.interestId) {
          if (this.appDetails.app_category?.toLowerCase().includes("clat")) {
            this.interestId = "TESTSERIES_CLAT_MOCK"
          }
          else if (this.appDetails.app_category?.toLowerCase().includes("sat")) {
            this.interestId = "TESTSERIES_SAT_MOCK"
          }
          else if (this.appDetails.app_category?.toLowerCase().includes("cuet")) {
            if (this.appDetails.app_category?.toLowerCase().includes("science")) {
              this.interestId = "TESTSERIES_CUET_SCIENCE_MOCK"
            }
            else if (this.appDetails.app_category?.toLowerCase().includes("commerce")) {
              this.interestId = "TESTSERIES_CUET_COMMERCE_MOCK"
            }
            else if (this.appDetails.app_category?.toLowerCase().includes("humanities")) {
              this.interestId = "TESTSERIES_CUET_HUMANITIES_MOCK"
            }
          }
        }
      }
    },
    /**
     * getQuizReportList
     */
    async getQuizReportList () {
      const payload = {
        app_id: this.appId,
        other_user_id: this.gideUserId,
        aprs_id: this.aprsId
      }

      if (this.attempt) {
        payload.attempt = this.attempt
      }

      const quizReportListResp = await QuizAnswers.quizAnswersCountReport(this, payload)
      if (quizReportListResp.resp_status) {
        this.quizReport = quizReportListResp.resp_data.data[0]
        if (this.quizReport?.chained_apps?.length) {
          const chainOrder = this.quizResultDetail?.chains?.map((chainedApp) => chainedApp.app_name) ?? []
          this.quizReport.chained_apps.sort((a, b) => chainOrder.indexOf(a.app_name) - chainOrder.indexOf(b.app_name))
        }
      }
    },
    /**
     * goto Next App Analysis
     */
    gotoNextAppAnalysis (item) {
      this.questionList = this.questionGridData[item.app_name]
    },
    /**
     * goto Edit Quiz/App
     */
    gotoEditQuiz (appId) {
      window.open(`${process.env.VUE_APP_SERVER_URL}/quiz_edit/${appId}`, "_blank")
    },
    /**
     * Get User Response Color
     */
    getOptionColor (ques, getClass = false) {
      const userResp = ques?.user_response ? ques.user_response.toUpperCase() : ""

      let color = "#dc3545 !important" // default red for wrong
      let classColor = "bg_red"

      if (ques.answer_image) {
        // blue for FRQ User has Uploaded the answer image so cannot determin the correct answer
        color = "#0d6efd !important"
        classColor = "bg_blue"
      }
      else if (userResp?.toLowerCase() == "z") {
        // orange for not attempted
        color = "#FFA500 !important"
        classColor = "bg_orange"
      }
      else if (!userResp || userResp.replaceAll(" ", "").length == 0) {
        // red for a blank/whitespace-only response, same as a wrong answer, so the user knows it was scored as incorrect
        color = "#dc3545 !important"
        classColor = "bg_red"
      }
      else if (ques?.answer_result == 1) {
        // green for correct
        color = "#28a745 !important"
        classColor = "bg_green"
      }
      else {
        // red for wrong
        color = "#dc3545 !important"
        classColor = "bg_red"
      }

      if (getClass) {
        // return `table_pill_badge_box rounded pl-2 pr-2 pointer ${color}`
        return `table_pill_badge_box ${classColor} rounded pl-2 pr-2 pointer`
      }
      else {
        return color
      }
    },
    /**
     * Format/display user response. If response is a division like "4/225",
     * compute and return the decimal (trimmed), otherwise return formatted text.
     */
    displayUserResponse (userResp) {
      try {
        if (userResp === null || userResp === undefined) return "-"
        let resp = String(userResp).trim()
        if (resp === "" || resp.toLowerCase() === "z") return "-"

        return resp

        /*
        const divMatch = resp.match(/^\s*([-+]?\d*\.?\d+)\s*\/\s*([-+]?\d*\.?\d+)\s*$/)
        if (divMatch) {
          const num = parseFloat(divMatch[1])
          const den = parseFloat(divMatch[2])
          if (Number.isNaN(num) || Number.isNaN(den) || den === 0) return resp
          const val = num / den
          if (Number.isInteger(val)) return String(val)
          return String(parseFloat(val.toFixed(6)))
        }

        if (resp.length > 5) return resp.substring(0, 5) + "..."
        return resp.toUpperCase()
        */
      }
      catch (err) {
        console.error("displayUserResponse error:", err)
        return String(userResp)
      }
    },
    /**
     * Tooltip explaining the user response cell is shown as a dash
     */
    getUserResponseTooltip (item) {
      const resp = item?.user_response ? String(item.user_response).trim() : ""
      if (resp.toLowerCase() === "z") {
        return "Not attempted"
      }
      if (!resp) {
        return "User did not provide an answer for this question"
      }
      return ""
    },
    /**
    * quizQuestionviewv1
    */
    quizQuestionviewV1 (type, item, questionNumber) {
      try {
        if (type === "FULLPAGE") {
          window.open("/quiz_question_view/" + this.QuestionQuizViewObj.qbk_id)
        }
        else {
          this.QuestionQuizViewObj = { ...item, appDetails: this.appDetails, questionNumber: questionNumber }
          this.showModelQuestionQuizViewV1 = true
        }
      }
      catch (err) {
        console.error("Exception occurred at quizQuestionviewV1() and Exception:", err.message)
      }
    },
    /**
     * closeQuestionQuizViewModalV1
     */
    async closeQuestionQuizViewModalV1 (keepModalOpen = false) {
      // Refresh Total, Section & AP scores after grading. Skipped for SAT as its score calculation adds up into SAT_FINAL_CHAIN_LIST on every call
      if (!this.isPSAT && !this.appCategory.includes(this.appNameWithSAT)) {
        await this.getResultDetail()
      }
      await this.getAppAnswerExplanation()
      await this.getQuizReportList()
      if (!keepModalOpen) {
        this.showModelQuestionQuizViewV1 = false
      }
    },
    /**
     * removeUnwantedText
     */
    removeUnwantedText (text) {
      if (!text.includes(":")) return text
      return text.split(":")[1].trim()
    },
    /**
     * get Test Name
     */
    getTestName (examDetail) {
      try {
        let appName = examDetail.app_name
        if (examDetail.app_type == "testseries") {
          examDetail.app_name = examDetail.app_name.split(":")[0]
        }

        if (!examDetail.app_name) {
          examDetail.app_name = appName
        }
        return examDetail.app_name
      }
      catch (err) {
        console.error("getTestName error:", err)
        return ""
      }
    },
    /**
     * get Category Time Spent
     */
    getCategoryTimeSpent (examDetail, showRawData = false) {
      if (!examDetail || !this.quizReport || !this.quizReport || !this.quizReport.chained_apps) {
        return null // Handle cases where data is missing
      }

      const matchedApp = this.quizReport.chained_apps.find(chainedApp => {
        return chainedApp.app_id === examDetail.app_id
      })

      if (matchedApp) {
        if (this.VUE_APP_TRUSTED_EMAILS.includes(this.userData.user_email) && showRawData) {
          return matchedApp.total_q_time_spent
        }

        if ((!matchedApp.total_q_time_spent) || (matchedApp.total_q_time_spent > matchedApp.app_duration)) {
          return matchedApp.app_duration
        }
        else if (matchedApp.total_q_time_spent <= 0) {
          return 0
        }
        else {
          return matchedApp.total_q_time_spent
        }
      }
      else {
        return 0 // Return null if no matching app is found
      }
    },
    /**
     * getCompleteTimeTaken
     */
    getCompleteTimeTaken (quizReport, showRawData = false) {
      if (this.VUE_APP_TRUSTED_EMAILS.includes(this.userData.user_email) && showRawData) {
        return quizReport.complete_time_spent
      }

      if ((!quizReport.complete_time_spent) || (quizReport.complete_time_spent > quizReport.complete_app_duration)) {
        return quizReport.complete_app_duration
      }
      else if (quizReport.complete_time_spent <= 0) {
        return 0
      }
      else {
        return quizReport.complete_time_spent
      }
    },
    /**
     * openSendmailToUserModal
     */
    openSendmailToUserModal () {
      const testName = this.getTestName(this.appDetails)

      // Construct the report link dynamically
      const baseUrl = process.env.VUE_APP_SERVER_URL
      const attemptVal = this.attempt || 1
      const reportLink = `${baseUrl}/app_result_view_v1/${this.appId}/${this.gideUserId}/${this.aprsId}/${attemptVal}`

      // Prepare the sendMailObj
      this.sendMailObj = {
        module_name: "testprep",
        user_id: this.userDetails.user_id,
        user_name: this.userDetails.user_name,
        user_email: this.userDetails.user_email,
        module_obj_id: this.appId,
        email_template_id: "EMAIL_TESTPREP_MOCK_REPORT_SEND",
        report_link: reportLink,
        EXAM_NAME: testName,
        subject: {}
      }

      // Populate subjects and process macro variables
      for (let key in this.SendMailModules) {
        let value = this.SendMailModules[key]

        // Replace {EXAM_NAME} macro with the test name
        if (typeof value === "string" && value.includes("{EXAM_NAME}")) {
          value = value.replace("{EXAM_NAME}", testName)
        }

        this.sendMailObj.subject[key] = value
      }

      this.showModelSendMail = true
    },
    /**
     * toggleResultPublish
     * Publishes an unpublished attempt and vice versa for all the apps of the attempt
     */
    async toggleResultPublish () {
      const deleted = this.resultDeleted === this.RESULT_UNPUBLISHED ? this.RESULT_PUBLISHED : this.RESULT_UNPUBLISHED
      this.publishInProgress = true
      try {
        const publishResp = await AppResults.appResultsAllPublishUnpublish(this, { aprs_id: this.aprsId, deleted })
        if (!publishResp) {
          return
        }

        ApiResponse.responseMessageDisplay(this, publishResp)
        if (publishResp.resp_status) {
          this.quizResultDetail.deleted = deleted
          // Publish clears every app, Unpublish is applied to the FRQ app(s) only (same as the API)
          for (const chainedApp of this.quizResultDetail.chains ?? []) {
            if (deleted === this.RESULT_PUBLISHED || chainedApp.frq_count > 0) {
              chainedApp.deleted = deleted
            }
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at toggleResultPublish() and Exception:", err.message)
      }
      finally {
        this.publishInProgress = false
      }
    },
    /**
     * emitCloseSendmailToUserModal
     */
    async emitCloseSendmailToUserModal () {
      this.showModelSendMail = false
    }
  },
  watch: {
    "$route.path": async function () {
      // Keep these in sync with mounted() - navigating between attempts/apps in-app reuses this component instance,
      // so leaving aprsId/attempt/gideUserId/interestId stale here made the fetch calls below use the previous attempt's data
      this.appId = this.$route.params.appId
      this.gideUserId = this.$route.params.gide_user_id ? this.$route.params.gide_user_id : this.userData.user_id
      this.aprsId = this.$route.params.aprsId
      this.interestId = this.$route.query.interest_id ? this.$route.query.interest_id : null
      this.attempt = this.$route.query.attempt ? this.$route.query.attempt : null

      this.offset = 1
      this.dontCallAPI = false
      await this.getResultDetail()
      this.getQuizReportList()
      this.getAppAnswerExplanation(true)
      this.updateResult = Math.random()
    }
  }
}
</script>

<style lang="scss" scoped>
  .que_img{
    min-width: 220px;
    width: 100%;
    max-width: max-content;
    margin-bottom: 25px;
  }
  h4 {
    padding: 12px 13px 18px;
    padding-left: 0;
    & svg {
      width: 25px;
      height: 21px;
      position: relative;
      top: 3px;
      margin-right: 6px;
      vertical-align: baseline;
    }
  }
  .option_tag{
  text-transform: capitalize;
  font-weight: 600;
  margin-right: 10px;
  border: 1px solid var(--iq-body-text);
  padding: 1px 8px;
  border-radius: 30px;
  color: var(--iq-body-text);
  height: 30px;
  width: 29px;
  position: relative;
  top: -3px;
  }
  .bg_green {
    background-color: rgb(0, 128, 0, 0.5) !important;
    border: 1px solid rgba(3, 68, 3, 0.5);
    color: #fff;
    width: 30px;
    width: max-content;
  }
  .bg_red {
    background-color: rgb(245, 53, 53);
    border: 1px solid rgb(204, 46, 46);
    color: #fff;
    width: max-content;
  }
  .bg_orange{
    background-color: rgb(255, 165, 0) !important;
    border: 1px solid rgb(255, 165, 0) !important;
    color: #fff;
    width: max-content;
  }
  .bg_blue{
    background-color: #0d6efd !important;
    border: 1px solid #0d6efd !important;
    color: #fff;
    width: max-content;
  }
  .iq-header-title{
  width: 100%;
  }
  .pill_badge_box{
    width: 30px;
    border-radius: 100% !important;
    margin-bottom: 5px;
    height: 30px;
    line-height: 21px !important;
    text-align: center;
    padding: 0px !important;
    padding-top: 5px !important;
    margin-right: 8px;
  }
  @media (max-width: 576px) {
    .quiz-report td {
      display: block;
      width: 100% !important; /* makes td full width */
    }

    .quiz-report tr {
      display: block;
    }
  }
  .twoLineOnly {
    min-height: unset;
  }
  .total-score{
    /* border-bottom: 1px dashed #dddddd; */
    padding-bottom: 5px;
  }
  .sccore-outline-box .score-outline-badge {
    --bs-badge-bg: transparent;
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    color: var(--iq-primary) !important;
    border: 1px solid var(--iq-primary) !important;
    box-shadow: none !important;
  }
  .right_bar{
    border-right: 1px solid #dddddd;
  }
  @media (min-width: 991px) {
    .name_deatils{
      float: right;
    }
  }
  /* Edge to edge evaluation notice at the bottom of the header card (negative margin cancels the 20px iq-card-header padding) */
  .unpublished-msg{
    margin: 0 -20px;
    padding: 10px 20px;
    border-left: 4px solid var(--iq-primary);
    border-radius: 0 0 5px 5px;
    background-color: rgba(227, 31, 38, 0.06);
    line-height: 1.4;
  }
  .unpublished-msg-desc{
    font-size: 13px;
  }
  .unpublished-msg.published-msg{
    border-left-color: green;
    background-color: rgba(0, 128, 0, 0.06);
  }
</style>
